module.exports = __webpack_public_path__ + "static/img/home-banners2.270e4f08.jpg";